import { matches } from '@/hooks/useIntervalRound';

const TICKS = [-50, -25, 0, 25, 50];

// Compact needle: cents from the requested interval (center = perfect).
export const MiniIntervalTuner = ({ interval, pitch, target }) => {
  const ok = matches(interval, target);
  const cents = ok ? Math.max(-50, Math.min(50, interval.cents)) : 0;
  const inTune = ok && Math.abs(interval.cents) <= 5;
  const status = !pitch ? 'In ascolto…' : ok ? (inTune ? 'Perfetto' : interval.cents < 0 ? 'Calante ♭' : 'Crescente #') : 'Non è l\'intervallo richiesto';
  return (
    <div data-testid="interval-mini-tuner" className="w-full max-w-sm mt-2 flex flex-col gap-1.5">
      <div className="flex items-baseline justify-between text-xs">
        <span data-testid="interval-mini-note" className={`font-bebas text-2xl leading-none ${!pitch ? 'text-white/20' : inTune ? 'text-emerald-300' : ok ? 'text-white' : 'text-pink-300'}`}>
          {pitch ? `${pitch.note}${pitch.octave}` : '--'}
        </span>
        <span data-testid="interval-mini-status" className={`text-[10px] uppercase tracking-[0.2em] ${inTune ? 'text-emerald-300' : ok ? 'text-white/60' : 'text-white/40'}`}>{status}</span>
        <span data-testid="interval-mini-cents" className="font-mono text-white/60 w-16 text-right">{ok ? `${interval.cents > 0 ? '+' : ''}${interval.cents} c` : '— c'}</span>
      </div>
      <div className="relative h-8 rounded-lg bg-[#0A0A0A] border border-white/5 overflow-hidden">
        <div className="absolute left-1/2 -translate-x-1/2 inset-y-1 w-[10%] rounded bg-emerald-400/10 border border-emerald-400/30" />
        {TICKS.map((t) => (
          <div key={t} className={`absolute top-1/2 -translate-y-1/2 w-px ${t === 0 ? 'h-6 bg-emerald-400/60' : 'h-3 bg-white/15'}`} style={{ left: `${50 + t}%` }} />
        ))}
        <div
          data-testid="interval-mini-needle"
          className={`absolute inset-y-1 w-1.5 -ml-[3px] rounded-full transition-[left,background-color] duration-100 ease-out ${!ok ? 'bg-white/15' : inTune ? 'bg-emerald-400 shadow-[0_0_12px_rgba(52,211,153,0.9)]' : 'bg-pink-400 shadow-[0_0_10px_rgba(236,72,153,0.7)]'}`}
          style={{ left: `${50 + cents}%` }}
        />
      </div>
      <div className="flex justify-between text-[9px] uppercase tracking-[0.25em] text-white/30">
        <span>♭</span><span>In Tune</span><span>#</span>
      </div>
    </div>
  );
};
